//电站列表
export const PSINFO_LIST_LOAD='psinfo/list/PSINFO_LIST_LOAD';
export const GET_PSINFOR_LIST='header/psinfolist/GET_PSINFOR_LIST';
export const SET_PSINFOR_LIST='header/psinfolist/SET_PSINFOR_LIST';
export const SELECT_PS='header/psinfolist/SELECT_PS';
export const SET_PSINFO='header/psinfolist/SET_PSINFO';
export const SET_ALLPS='header/psinfolist/SET_ALLPS';